import { render, staticRenderFns } from "./standard-process-edit.vue?vue&type=template&id=0a0f3b06&scoped=true"
import script from "./standard-process-edit.vue?vue&type=script&lang=js"
export * from "./standard-process-edit.vue?vue&type=script&lang=js"
import style0 from "./standard-process-edit.vue?vue&type=style&index=0&id=0a0f3b06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f3b06",
  null
  
)

export default component.exports